module.exports = __webpack_public_path__ + "images/icons_v2/star-none-green-37bc49ab.svg";